import { render } from "./CdaContentBody.vue?vue&type=template&id=1eb8c6bc&scoped=true"
import script from "./CdaContentBody.vue?vue&type=script&lang=js"
export * from "./CdaContentBody.vue?vue&type=script&lang=js"

import "./CdaContentBody.vue?vue&type=style&index=0&id=1eb8c6bc&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1eb8c6bc"]])

export default __exports__